import React from 'react';
import { Route, Switch } from 'react-router-dom';
import DailyScripturesList from './dailyScripturesList';
import EditScripturePage from './editScripture';

export default class DailyScriptures extends React.Component {
  render() {
    return (
      <Switch>
        <Route exact path="/dashboard/admin/scripturesList" component={DailyScripturesList} />
        <Route exact path="/dashboard/admin/scripturesList/updateScripture/:scriptureId?" component={EditScripturePage} />
      </Switch>
    );
  }
}



// WEBPACK FOOTER //
// ./src/components/pages/dailyScriptures/dailyScriptures.js